/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type {
  UpdateVQResponsesErrorResponse,
  UpdateVQResponsesRequest,
  UpdateVQResponsesResponse,
} from './api.schemas';

import { api } from '../util/http';

export const updateEncountersResponses = (
  encounterId: number,
  updateVQResponsesRequest: UpdateVQResponsesRequest,
) => {
  return api<UpdateVQResponsesResponse>({
    url: `/api/encounters/${encounterId}/responses`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateVQResponsesRequest,
  });
};

export const getUpdateEncountersResponsesMutationOptions = <
  TError = UpdateVQResponsesErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEncountersResponses>>,
    TError,
    { encounterId: number; data: UpdateVQResponsesRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEncountersResponses>>,
  TError,
  { encounterId: number; data: UpdateVQResponsesRequest },
  TContext
> => {
  const mutationKey = ['updateEncountersResponses'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEncountersResponses>>,
    { encounterId: number; data: UpdateVQResponsesRequest }
  > = (props) => {
    const { encounterId, data } = props ?? {};

    return updateEncountersResponses(encounterId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEncountersResponsesMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEncountersResponses>>
>;
export type UpdateEncountersResponsesMutationBody = UpdateVQResponsesRequest;
export type UpdateEncountersResponsesMutationError = UpdateVQResponsesErrorResponse;

export const useUpdateEncountersResponses = <
  TError = UpdateVQResponsesErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateEncountersResponses>>,
      TError,
      { encounterId: number; data: UpdateVQResponsesRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateEncountersResponses>>,
  TError,
  { encounterId: number; data: UpdateVQResponsesRequest },
  TContext
> => {
  const mutationOptions = getUpdateEncountersResponsesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
